import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

interface PaymentPlan {
  name?: string;
  downPayment?: number;
  years?: number;
  type?: string;
}

@Component({
  selector: 'app-project-payment-plans',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  template: `
    <div
      class="surface-card rounded-3xl p-6 md:p-8 antialiased"
    >
      <div class="flex items-center justify-between mb-6 pb-2 border-b border-border-subtle">
        <div class="flex items-center gap-2">
          <div class="w-1.5 h-3.5 bg-primary rounded-sm shadow-sm"></div>
          <h2 class="text-sm font-black text-text-primary uppercase tracking-wider font-mono">
            {{ 'projectsDetails.paymentPlans' | translate }}
          </h2>
        </div>

        <div
          class="flex items-center gap-1.5 px-2.5 py-1 bg-success-soft border border-success-border rounded-lg text-[10px] font-mono font-bold text-success"
        >
          <i class="fa-solid fa-shield-check"></i>
          <span>{{ 'projectsDetails.flexibleScheduling' | translate }}</span>
        </div>
      </div>

      <div class="space-y-3">
        @for (plan of paymentPlans; track plan.name) {
          <div
            class="group flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4.5 bg-surface-elevated/40 hover:bg-surface-elevated border border-border hover:border-border-primary rounded-2xl transition-all duration-200"
          >
            <div class="flex items-center gap-3.5">
              <div
                class="w-9 h-9 bg-surface border border-border rounded-xl flex items-center justify-center text-text-muted group-hover:text-primary group-hover:border-primary/30 shadow-sm shrink-0 transition-colors"
              >
                <i class="fa-solid fa-vault text-[11px]"></i>
              </div>

              <span
                class="text-xs md:text-sm font-semibold text-text-primary tracking-tight"
              >
                {{ plan.name }}
              </span>
            </div>

            <div class="flex items-center gap-2 self-end sm:self-auto pl-12 sm:pl-0">
              <div
                class="px-2.5 py-1 bg-primary-soft border border-primary/20 rounded-lg text-[10px] font-mono font-black text-primary uppercase tracking-wider"
              >
                @if(plan.downPayment) {
                  {{ plan.downPayment }}% {{ 'projectsDetails.downPayment' | translate }}
                } @else {
                  {{ 'projectsDetails.flexible' | translate }}
                }
              </div>

              <div
                class="px-2.5 py-1 bg-surface border border-border-strong rounded-lg text-[10px] font-mono font-bold text-text-secondary uppercase tracking-wider"
              >
                @if(plan.years) {
                  {{ plan.years }} {{ 'projectsDetails.years' | translate }}
                } @else {
                  {{ 'projectsDetails.installments' | translate }}
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class ProjectPaymentPlansComponent {
  @Input() paymentPlans: PaymentPlan[] = [];
}
